__turbopack_context__.v({
  "forced-error": "m0n36G_forced-error",
  "label": "m0n36G_label",
  "text": "m0n36G_text",
  "wrapper": "m0n36G_wrapper",
});
